const INITIAL_RATING_VALUE = 0;

export default INITIAL_RATING_VALUE;
